{
  "version": 1,
  "asset_id": "b9b09900-f52a-4761-808f-5e23ac77862e",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/b9b09900-f52a-4761-808f-5e23ac77862e/hero-home-poster.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/b9b09900-f52a-4761-808f-5e23ac77862e/hero-home-poster.jpg",
  "original_filename": "hero-home-poster.jpg",
  "size": 60764,
  "content_type": "image/jpeg",
  "created_at": "2026-09-27T18:56:20Z"
}
